// extracted by mini-css-extract-plugin
export var boxItems = "_c8-1";
export var boxItemsLg = "_c8-2";
export var button = "_c8-7";
export var buttonHoverless = "_c8-9";
export var buttonLg = "_c8-8";
export var filterGroupBox = "_c8-0";
export var icon = "_c8-3";
export var iconSecondary = "_c8-6";
export var iconWrapper = "_c8-4";
export var iconWrapperLg = "_c8-5";
export var truncatedLabel = "_c8-a";